import * as messageService from "../../services/message.service";
import * as clientService from '../../services/client.service';


const state = {
    clientAll:[],
    clientSingle:{},
};

const getters = {
    gettClientAll:state => (state.clientAll),
    gettClientSingle:state => (state.clientSingle),
};

const actions = {
    async fetchClientAll({ commit } ){
        try {
            const response = await clientService.all();
            commit('setClientAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchClientSingle({ commit } ){
        try {
            const response = await clientService.single();
            commit('setClientSingle', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setClientAll:(state, res) => (
        state.clientAll =  res
    ),
    setClientSingle:(state, res) => (
        state.clientSingle =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}